const ja = {
    translation: {
        loading: '読み込み中…',

        pageTitle: {
            home: 'ホーム',
            crochetGallery: 'かぎ針編み',
            knitGallery: '棒針編み',
            patternGallery: 'パターン',
            crochetEditor: 'かぎ針エディター',
            knitEditor: '棒針エディター',
            patternEditor: 'パターンエディター',
            tryCrochet: 'かぎ針エディターを試す',
            tryKnit: '棒針エディターを試す',
            settings: '設定',
            licenses: 'オープンソースライセンス',
            privacy: 'プライバシーと Cookie',
            terms: '利用規約',
            whatsNew: '新機能',
            crochetIcons: 'かぎ針編みアイコン',
            iconHandoff: 'アイコンハンドオフ',
            signIn: 'サインイン',
            signUp: '登録',
            waitlist: '順番待ちリスト',
        },

        settings: {
            label: '設定',
            info: '情報',
            apply: '適用',
            discard: '破棄',
            applying: '適用中…',
            saved: '設定を保存しました',
            customCursor: 'カスタムカーソル',
            inputMode: {
                label: '入力モード',
                mouse: 'キーボード + マウス',
                trackpad: 'トラックパッド',
            },
            fontSize: {
                label: '文字サイズ',
                small: '小',
                medium: '中',
                large: '大',
                'x-large': '特大',
                'xx-large': '極大',
            },
            bentoRadius: {
                label: 'パネルの角丸',
                description: 'エディターのパネル（キャンバス、ヘッダー、プロパティ列）の角の丸さ。',
                none: '角ばった',
                small: 'わずか',
                medium: '中',
                large: '丸い',
                'x-large': 'とても丸い',
            },
            canvasGrid: {
                label: 'キャンバスのグリッド',
                off: 'オフ',
                dots: 'ドット',
                lines: '線',
                ruler: 'ルーラー',
                snapToGrid: 'グリッドにスナップ',
            },
            canvasBackground: {
                label: 'キャンバスの背景',
                paper: 'ペーパー',
                white: 'ホワイト',
                linen: 'リネン',
                stone: 'ストーン',
                charcoal: 'チャコール',
                night: 'ナイト',
                custom: 'カスタムカラー',
                saturation: '彩度と明度',
                hue: '色相',
                hex: '16進カラーコード',
            },
            grabMode: {
                label: 'Gキー掴み',
                moveOnly: '移動のみ',
                allDrags: '全ドラッグ',
            },
            overlays: {
                label: 'オーバーレイ',
                roundNumbers: '段番号',
                stitchOrder: '編み目の順序',
                guides: 'ガイド',
            },
        },

        diagrams: {
            title: 'マイ編み図',
            newDiagram: '新規編み図',
            untitled: '無題',
            notFound: '編み図が見つかりません',
            loadFailed: 'この編み図を読み込めませんでした — 保存データは変更されていません',
            createFailed: '新しい編み図を作成できませんでした',
            saveStatus: {
                saving: '保存中…',
                saved: '保存済み',
                error: '保存できませんでした',
                tooLarge: 'サイズが大きすぎて同期できません——この端末にのみ保存されています',
                synced: '同期済み',
                syncing: '同期中…',
                offline: 'オフライン——この端末に保存済み',
            },
            save: '保存',
            lastSavedToday: '最終保存 今日 {{time}}',
            lastSavedOn: '最終保存 {{date}} {{time}}',
            conflict: '別のデバイスで変更されました——再読み込みして最新版を取得してください',
            offlineList: 'オフライン——この端末上のコピーを表示しています',
            storageUnavailable: 'ローカルストレージを利用できません — 変更は保存されません',
            listFailed: '編み図を読み込めませんでした',
            empty: '編み図はまだありません — 最初の1枚を作りましょう',
            renameLabel: '編み図の名前',
            rename: '名前を変更',
            delete: '削除',
            deleteTitle: '編み図を削除しますか？',
            deleteBody: '「{{name}}」は完全に削除されます。',
            cancel: 'キャンセル',
            confirmDelete: '削除',
            discardTitle: '同期されていない変更を破棄しますか？',
            discardBody: '「{{name}}」は他の端末で削除されました。ここにある同期されていない変更は失われます。この操作は取り消せません。',
            actionsMenu: '編み図の操作',
            renameFailed: '名前を変更できませんでした',
            deleteFailed: '削除できませんでした',
            deletedElsewhere: '他の端末で削除されました',
            deletedElsewhereBody: '同期されていない変更があります。',
            keepAsCopy: 'コピーとして保存',
            discard: '破棄',
            keepAsCopyFailed: 'コピーを保存できませんでした',
            discardFailed: '破棄できませんでした',
            openElsewhere: 'この編み図は別のタブで開かれています — 変更が競合する可能性があります',
            aiEditing: 'AIが編集中…',
            updatedElsewhere: 'この編み図は別のセッションで更新されました',
            deletedTitle: 'この編み図は削除されました',
            deletedBody:
                '「{{name}}」は他の端末で削除されました。ここには同期されていない変更があります。保持すると、あなたのバージョンが新しい編み図として保存されます——元の編み図は復元できません。',
            deletedKeep: '新しい編み図として保持',
            deletedDiscard: '破棄して閉じる',
            deletedBodyOpenCopy:
                '「{{name}}」は別の端末で削除されました。この端末にあるコピーを新しい編み図として保存できますが、元の編み図は復元できません。',
            syncConflictTitle: 'オフライン中の変更は同期されませんでした',
            syncConflictBody:
                'この端末がオフラインの間に「{{name}}」が別の端末で変更されたため、こちらの変更は元の編み図に保存されていません。新しい編み図として保存するか、変更を破棄してください。',
            syncConflictKeep: '新しい編み図として保存',
            syncConflictDiscard: '自分の変更を破棄',
            syncUnavailable: '現在、この編み図ではリアルタイム同期を利用できません。変更はこの端末に保存されています。',
            syncLoadFailed: 'この編み図を開けませんでした。リアルタイム同期に接続できません。接続を確認して、もう一度お試しください。',
            archive: 'アーカイブ',
            archiveDone: '「{{name}}」をアーカイブに移動しました',
            archiveFailed: '編み図をアーカイブできませんでした',
            archivedTitle: 'アーカイブ済み',
            archivedEmpty: 'アーカイブされた編み図はありません。アーカイブすると編み図は読み取り専用でここに残り、アクティブな編み図の枠が空きます。',
            unarchive: 'アーカイブを解除',
            unarchiveDone: '「{{name}}」が再びアクティブになりました',
            unarchiveFailed: '編み図のアーカイブを解除できませんでした',
            localOnly: 'この端末にのみ保存',
            localOnlyOverLimit: '無料プランの上限を超えているため、アカウントには保存されていません',
        },

        sharing: {
            menuItem: '共有',
            dialogTitle: '「{{name}}」を共有',
            linkSection: 'リンク',
            createLink: 'リンクを作成',
            linkActive: 'リンクを知っている全員が閲覧できます',
            copyLink: 'リンクをコピー',
            linkCopied: 'リンクをコピーしました',
            rotateLink: 'リンクを再発行',
            revokeLink: 'オフにする',
            linkHidden: 'このリンクはURL保存機能より前に作成されたため表示できません — リンクをリセットして新しいURLを取得してください。',
            peopleSection: 'メンバー',
            emailPlaceholder: 'メールアドレス',
            invite: '招待',
            pendingBadge: '保留中',
            invitePending: 'このメールのアカウントはまだありません — そのメールでサインインすると閲覧できるようになります。',
            removePerson: '削除',
            allowCopy: '閲覧者はコピーを保存できる',
            requestFailed: '共有リクエストに失敗しました — もう一度お試しください',
            loading: '共有設定を読み込み中…',
            viewOnly: '閲覧のみ',
            saveCopy: 'コピーを保存',
            copySaved: 'マイ編み図に保存しました',
            copyForbidden: 'オーナーがこの編み図のコピーを無効にしています',
            copyFailed: 'コピーを保存できませんでした — もう一度お試しください',
            signInToCopy: 'サインインしてコピーを保存',
            linkUnavailable: 'この共有リンクは無効になりました',
            sharedNotFound: 'この共有編み図は無効になりました',
            sharedWithMe: '自分と共有',
            menuItemArchived: '共有',
            archivedNote:
                'この編み図はアーカイブ済みのため、共有範囲を縮小することしかできません。リンクを無効にする、共有相手を削除する、コピーを禁止することはできます。共有を拡大するには、アーカイブを解除してください。',
        },

        tryEditor: {
            defaultName: {
                crochet: 'はじめてのかぎ針編み図',
                knitting: 'はじめての棒針編み図',
            },
            signUpCta: '無料で登録',
            wall: {
                title: {
                    export: '無料登録してエクスポート',
                    share: '無料登録して共有',
                    newDiagram: '無料登録してさらに作成',
                },
                body: '作品はそのまま引き継がれます。ここで作ったものはすべてアカウントに保存されます。',
                cta: '無料で登録',
                dismiss: '編集を続ける',
            },
            claimed: '作品をアカウントに追加しました。',
        },

        billing: {
            limit: {
                title: '無料プランの上限に達しました',
                body:
                    '無料プランで保存できるアクティブな編み図は {{limit}} 件までです。1 件アーカイブすると空きができます。アーカイブした編み図はアカウントに読み取り専用で残り、空きができれば元に戻せます。',
                bodyNoLimit:
                    '無料プランで利用できるアクティブな編み図の枠をすべて使用しています。1 件アーカイブすると空きができます。アーカイブした編み図はアカウントに読み取り専用で残り、空きができれば元に戻せます。',
                archive: 'アーカイブ',
                archiveNamed: '「{{name}}」をアーカイブ',
                archiveFailed: '編み図をアーカイブできませんでした。もう一度お試しください。',
                loading: '編み図を読み込み中…',
                empty: 'アカウントにアーカイブできる編み図がまだありません。この端末にのみ保存されている編み図は、アップロード後にアーカイブできます。',
                kind: {
                    crochet: 'かぎ針編み',
                    knitting: '棒針編み',
                },
                dismiss: '今はしない',
                checkout: 'Pro にアップグレード',
                proUnavailable: 'Pro はまだご利用いただけません。',
            },
            saveStatus: {
                overLimit: 'この端末に保存済み——無料プランの上限を超えています',
                proRequired: 'この端末に保存済み——パターンには Pro が必要です',
            },
            upgrade: {
                patternComposer: {
                    title: 'パターン文書の作成・編集は Pro 限定です',
                    body: 'パターン文書を作成・編集するには Pro にアップグレードしてください。既存のパターン文書は引き続き閲覧・印刷できます。',
                },
                dismiss: '今はしない',
                checkout: 'Pro にアップグレード',
                proUnavailable: 'Pro はまだご利用いただけません。',
            },
        },

        patterns: {
            title: 'マイパターン',
            newDiagram: '新しいパターン',
            untitled: '無題',
            notFound: 'パターンが見つかりません',
            loadFailed: 'このパターンを読み込めませんでした——内容は変更されていません',
            needsNewer: {
                title: 'このパターンには新しいバージョンの {{appName}} が必要です',
                body: "新しいバージョンのアプリで保存されたパターンです。再読み込みして更新してください——パターンは安全で、内容は変更されていません。",
                reload: '再読み込み',
                back: 'パターン一覧に戻る',
            },
            createFailed: '新しいパターンを作成できませんでした',
            saveStatus: {
                saving: '保存中…',
                saved: '保存済み',
                error: '保存できませんでした',
                tooLarge: 'サイズが大きすぎて同期できません——この端末にのみ保存されています',
            },
            save: '保存',
            lastSavedToday: '今日 {{time}} に保存されました',
            lastSavedOn: '{{date}} {{time}} に保存されました',
            conflict: '別の端末で変更されました——最新の内容を取得するには再読み込みしてください',
            offlineList: 'オフライン——この端末のコピーを表示しています',
            storageUnavailable: 'ローカルストレージを利用できません——変更は保存されません',
            listFailed: 'パターンの一覧を読み込めませんでした',
            empty: 'まだパターンがありません——最初のパターンを作成しましょう',
            renameLabel: 'パターン名',
            rename: '名前を変更',
            delete: '削除',
            deleteTitle: 'パターンを削除しますか？',
            deleteBody: '「{{name}}」は完全に削除されます。',
            cancel: 'キャンセル',
            confirmDelete: '削除',
            discardTitle: '同期されていない変更を破棄しますか？',
            discardBody: '「{{name}}」は他の端末で削除されました。ここにある同期されていない変更は失われます。この操作は取り消せません。',
            actionsMenu: 'パターンの操作',
            renameFailed: 'パターンの名前を変更できませんでした',
            deleteFailed: 'パターンを削除できませんでした',
            deletedElsewhere: '他の端末で削除されました',
            deletedElsewhereBody: '同期されていない変更があります。',
            keepAsCopy: 'コピーとして保存',
            discard: '破棄',
            keepAsCopyFailed: 'コピーを保存できませんでした',
            discardFailed: '破棄できませんでした',
            localOnly: 'この端末にのみ保存',
            readOnlyBanner: '閲覧のみ：パターンの編集には Pro が必要です。このパターンは引き続き印刷できます。',
            readOnlyUpgrade: 'アップグレード',
        },

        info: {
            title: 'バージョン情報',
            version: 'バージョン',
            environment: '環境',
            build: 'ビルド',
            licensesLink: 'オープンソースライセンス',
            offline: {
                installedVersion: 'インストール済みのバージョン',
                installedOn: 'インストール日',
                licence: 'ライセンスID',
                checkForUpdates: 'アップデートを確認',
                notInstalled: 'この端末にはインストール情報が見つかりません。',
                backupNote: '空き容量が少なくなると、ブラウザがこのアプリのデータを削除することがあります。作品をバックアップしてください。',
                backupLink: 'すべてエクスポート',
                pasteUpdateCode: 'アップデートコードを貼り付け',
                applyUpdateCode: 'アップデート',
                notAnUpdateCode: 'これはアップデートコードではありません。',
                updateCodeExpired: 'このコードは有効期限が切れています。「アップデートを確認」をクリックして新しいコードを取得してください。',
            },
        },

        // Pattern-language text (read with patternT): the running footer preset. Single braces are tokens, not i18next.
        headerFooter: {
            pageOfPages: '{page} / {pages} ページ',
        },
        legend: {
            menuItem: '使用している編み方',
            title: '使用している編み方',
            description: 'この編み図で使われている編み方の種類',
            empty: 'まだ編み目がありません',
            increase: '増し目',
            decrease: '減らし目',
            clusterStitch: '{{memberCount}}{{member}}玉編み',
            clusterSpace: '{{memberCount}}{{member}}玉編み（束に編み入れ）',
            popcornStitch: '{{memberCount}}{{member}}ポップコーン編み',
            popcornSpace: '{{memberCount}}{{member}}ポップコーン編み（束に編み入れ）',
        },

        diagramText: {
            menuItem: 'テキストを生成',
            title: 'パターンテキスト',
            description: 'この図からの文章による説明',
            empty: 'まだ説明する内容がありません',
            copy: 'コピー',
            row: '段',
            round: '周',
            increase: '増し目',
            decrease: '減らし目',
            inChSpace: '鎖 {{count}} 目の空間に',
            clusterLabel: '{{memberCount}}{{member}}玉編み',
            clusterInSpace: '（束に編み入れ）',
            popcornLabel: '{{memberCount}}{{member}}ポップコーン編み',
            popcornInSpace: '（束に編み入れ）',
            unassignedRound: '一部の目に段が割り当てられていません',
            orderUnverified: '順序が未確認',
            cross: '交差{{stitch}}',
            turningChain: '立ち上がり',
            turn: '裏返す',
        },

        diagramRounds: {
            panelTitle: '段',
            roundLabel: '{{n}} 段目',
            unassigned: '未割り当て',
            stitchCount_one: '{{count}} 目',
            stitchCount_other: '{{count}} 目',
            showHalo: 'この段を強調表示',
            hideHalo: 'この段の強調表示を解除',
            empty: 'まだ段がありません',
            collapseAll: 'すべて折りたたむ',
            expandAll: 'すべて展開',
            expandSection: 'セクションを展開',
            collapseSection: 'セクションを折りたたむ',
        },

        viewer: {
            viewOnly: '閲覧のみ',
            backToGallery: 'マイ編み図へ戻る',
            storageUnavailable: 'ローカルストレージを利用できないため、編み図を読み込めません',
            archivedTitle: 'アーカイブ済み：読み取り専用',
            archivedBody: '再び編集するにはアーカイブを解除してください。',
        },

        crochetViewer: {
            inspectorTitle: '詳細',
            typeLabel: '編み目',
            roundLabel: '段／周',
            orderLabel: '順序',
            colorLabel: '色',
            multiSelected: '{{count}} 個の目を選択中',
        },

        licenses: {
            title: 'オープンソースライセンス',
            intro: '{{appName}} は以下のオープンソースプロジェクトを利用しています。作者の皆さまに感謝します。',
        },

        appearance: {
            title: '外観',
            description: 'お好みのカラーテーマを選択してください。',
            signInPrompt: '設定を管理するにはサインインしてください。',
            loading: '設定を読み込み中…',
            saveError: 'テーマの保存に失敗しました。もう一度お試しください。',
            theme: {
                label: 'テーマ',
                light: 'ライト',
                dark: 'ダーク',
                system: 'システム',
            },
        },

        settingsPage: {
            title: '設定',
            nav: {
                appearance: '外観',
                crochet: 'かぎ針編み',
                account: 'アカウント',
                billing: 'お支払い',
                offlineApp: 'オフラインアプリ',
                yourData: 'データ管理',
                hotkeys: 'ショートカット',
                info: '情報',
                connectAi: 'AI連携',
            },
            language: {
                label: '言語',
            },
            account: {
                manageButton: 'アカウントを管理',
                signedOutPrompt: 'アカウントを表示するにはサインインしてください。',
                noName: '名前なし',
            },
            billing: {
                title: 'お支払い',
                intro: 'サブスクリプションに登録すると、エディターのすべての機能を利用できます。購入手続きを完了するため決済サービスへ移動し、その後このページに戻ります。',
                signInPrompt: 'お支払いを管理するにはサインインしてください。',
                checkoutButton: '購入手続きへ進む',
                unavailable: '現在、購入手続きをご利用いただけません。しばらくしてからもう一度お試しください。',
                onPro: '現在、Pro プランをご利用中です。',
                foundingBadge: '創設デザイナー',
                foundingNote: 'このプランは付与されたものなので、お支払いや解約の手続きは不要です。',
                renewsOn: '{{date}} に更新されます。',
                endsOn: 'アクセスは {{date}} に終了します。',
                lapsed: 'サブスクリプションは終了しました。再登録すると、エディターのすべての機能を再び利用できます。',
                manageButton: 'サブスクリプションを管理',
                loadError: 'お支払い情報を読み込めませんでした。しばらくしてからもう一度お試しください。',
                portalError: 'お支払い管理ページを開けませんでした。もう一度お試しください。',
                cancelButton: 'サブスクリプションを解約',
                resumeButton: 'サブスクリプションを再開',
                cancelConfirmTitle: 'サブスクリプションを解約しますか？',
                cancelConfirmBody: '今後は更新されません。{{date}} まではこれまでどおりご利用いただけ、それまでならいつでも再開できます。',
                cancelConfirmBodyNoDate: '今後は更新されません。終了するまでならいつでも再開できます。',
                cancelConfirmKeep: '解約しない',
                cancelConfirmAction: '解約する',
                cancelled: 'サブスクリプションを解約しました。',
                resumed: 'サブスクリプションを再開しました。',
                cancelError: 'サブスクリプションを解約できませんでした。もう一度お試しください。',
                resumeError: 'サブスクリプションを再開できませんでした。もう一度お試しください。',
            },
            offlineApp: {
                title: 'オフラインアプリ',
                intro: 'この端末に {{appName}} をインストールすると、インターネットに接続していなくても作業を続けられます。',
                getButton: 'オフラインアプリを入手',
                opening: '開いています…',
                popupBlocked: 'インストールページを新しいタブで開こうとしましたが、ブラウザにブロックされました。',
                openInstallPage: 'インストールページを開く',
                dataCopyNote:
                    'Chrome と Edge では、インストール時に編み図とパターンがコピーされます。その他のブラウザでは、設定 → データ管理をご利用ください。',
                copying: 'オフラインアプリに作品をコピーしています… {{done}} / {{total}}',
                copied: 'コピーしました',
                copyFailed: 'コピーできませんでした。「すべてエクスポート」を使用し、オフラインアプリで「インポート」してください。',
                trial: 'オフラインアプリは有料プランに含まれています。',
                trialConverts: 'トライアルが有料プランに移行すると利用できるようになります。',
                subscribe: 'サブスクリプションに登録',
                signInPrompt: 'オフラインアプリを入手するにはサインインしてください。',
                loadError: 'プランの詳細を読み込めませんでした。しばらくしてからもう一度お試しください。',
                tokenError: {
                    not_entitled: 'お使いのアカウントにはオフラインアプリが含まれていません。サブスクリプションに登録すると入手できます。',
                    trial_not_eligible: 'オフラインアプリは有料プランに含まれています。',
                    rate_limited: '試行回数が多すぎます。しばらく待ってからもう一度お試しください。',
                    unavailable: '現在、オフラインアプリはご利用いただけません。しばらくしてからもう一度お試しください。',
                    failed: 'インストールページを開けませんでした。もう一度お試しください。',
                },
            },
            yourData: {
                title: 'データ管理',
                intro: 'すべての編み図とパターンをファイルに保存したり、ファイルから作品を取り込んだりできます。インポートで既存のデータが上書きされることはありません。',
                exportButton: 'すべてエクスポート',
                importButton: 'インポート…',
                exporting: 'エクスポート中 {{done}} / {{total}}…',
                checking: '確認中 {{done}} / {{total}}…',
                importing: 'インポート中 {{done}} / {{total}}…',
                importedName: '{{name}}（インポート）',
                count: {
                    diagram_one: '編み図 {{count}} 枚',
                    diagram_other: '編み図 {{count}} 枚',
                    pattern_one: 'パターン {{count}} 件',
                    pattern_other: 'パターン {{count}} 件',
                },
                export: {
                    done: '{{diagrams}}と{{patterns}}をエクスポートしました。',
                    unreadable: '{{count}} 件を読み込めませんでした。',
                    imagesMissing_one: '画像 {{count}} 枚を含められませんでした。',
                    imagesMissing_other: '画像 {{count}} 枚を含められませんでした。',
                },
                import: {
                    done: '{{diagrams}}と{{patterns}}をインポートしました。',
                    doneWithCopies_one:
                        '{{diagrams}}と{{patterns}}をインポートしました（うち {{count}} 件はコピーとして）。',
                    doneWithCopies_other:
                        '{{diagrams}}と{{patterns}}をインポートしました（うち {{count}} 件はコピーとして）。',
                    archived_one: '{{count}} 件の編み図は、無料プランの上限に達したためアーカイブされました。',
                    archived_other: '{{count}} 件の編み図は、無料プランの上限に達したためアーカイブされました。',
                    alreadyHere_one: '{{count}} 件はすでに存在します。',
                    alreadyHere_other: '{{count}} 件はすでに存在します。',
                    needsNewer_one: '{{count}} 件は新しいバージョンの {{appName}} が必要です。',
                    needsNewer_other: '{{count}} 件は新しいバージョンの {{appName}} が必要です。',
                    patternsSkipped_one: '{{count}} 件のパターンをスキップしました。パターンには Pro が必要です。',
                    patternsSkipped_other: '{{count}} 件のパターンをスキップしました。パターンには Pro が必要です。',
                    unreadable: '{{count}} 件を読み込めませんでした。',
                    tooLarge_one: '{{count}} 件はサイズが大きすぎて同期できません。',
                    tooLarge_other: '{{count}} 件はサイズが大きすぎて同期できません。',
                    failed: '{{count}} 件を保存できませんでした。',
                    imagesSkipped_one: '画像 {{count}} 枚をインポートできませんでした。',
                    imagesSkipped_other: '画像 {{count}} 枚をインポートできませんでした。',
                },
                notABundle: 'これは {{appName}} のファイルではありません。',
                tooNew: 'このファイルは新しいバージョンの {{appName}} で作成されています。開くにはアップデートしてください。',
                unreachable: '{{appName}} に接続できません。接続を確認して、もう一度お試しください。',
                unavailable: 'このブラウザではストレージを利用できません。',
                exportFailed: '作品をエクスポートできませんでした。もう一度お試しください。',
                importFailed: 'このファイルをインポートできませんでした。もう一度お試しください。',
            },
            crochet: {
                defaultSizingTab: 'デフォルトサイズ',
                description: '各編み目のデフォルトサイズです。新規作成した編み図にのみ適用され、既存の編み図は作成時のデフォルト設定を維持します。',
                saveError: 'デフォルトサイズの保存に失敗しました。もう一度お試しください。',
                signInPrompt: 'デフォルトサイズを編集するにはサインインしてください。',
                loading: 'デフォルトサイズを読み込み中…',
                typeLabel: '編み目の種類',
                auto: '自動',
                resetType: 'この編み目をリセット',
                resetAll: 'すべてリセット',
                barLabel: 'バー{{n}}',
                capAngleFollowingHint: '「ガイド方向に追従」が有効な間は無効になります。',
                fields: {
                    'top-cap': 'トップキャップの長さ',
                    crossbar: 'クロスバーの長さ',
                    crossbar2: 'クロスバー2の長さ',
                    crossbar3: 'クロスバー3の長さ',
                    hook: 'フックサイズ',
                    width: '幅',
                    widthScale: '幅',
                    capAngle: 'キャップ角度',
                    crossbarAngle: 'クロスバー角度',
                    crossbarPos: 'クロスバー位置',
                    bodyGapTop: '上部の間隔',
                    bodyGapBase: '下部の間隔',
                    followTangent: 'ガイド方向に追従',
                    cap: 'キャップの長さ',
                },
                strokeTab: '線',
                strokeDescription: '編み目記号の線の太さと線端のスタイルです。新規作成した編み図にのみ適用され、既存の編み図は各自の設定を維持します。',
                strokeSaveError: '線の既定値の保存に失敗しました。もう一度お試しください。',
                strokeSignInPrompt: '線の既定値を編集するにはサインインしてください。',
                strokeLoading: '線の既定値を読み込み中…',
            },
            connectAi: {
                title: 'AIと連携する',
                intro:
                    'ClaudeやChatGPTが、あなたと同じツールを使ってひとつずつ操作しながら、一緒に編み図を作成します。必要なのは下のエンドポイントだけです。{{appName}}アカウントでサインインするだけで、クライアントIDやAPIキーをコピーする必要はありません。',
                supportedClients:
                    '現在連携できるのは、claude.ai（Claudeデスクトップアプリを含む）とChatGPTです。Claude Codeやその他のAIアプリには、まだ対応していません。',
                endpointLabel: 'MCPエンドポイント',
                copy: 'コピー',
                copied: 'クリップボードにコピーしました',
                copyError: 'コピーできませんでした——テキストを選択して手動でコピーしてください。',
                claudeAppTitle: 'claude.ai・Claudeデスクトップアプリ',
                claudeAppStepOpen: '設定 → コネクタを開き、カスタムコネクタを追加します。',
                claudeAppStepUrl:
                    '名前を{{appName}}にして、上記のMCPエンドポイントをURLに貼り付けます。OAuthのクライアントIDやシークレットは不要です — Claudeは自動的に自身を識別します。',
                claudeAppStepConnect: '接続を選択し、{{appName}}アカウントでサインインします。',
                chatgptTitle: 'ChatGPT',
                chatgptStepDevMode: 'ChatGPTの設定で開発者モード（Developer mode）をオンにします。有料プランでのみ利用できます。',
                chatgptStepCreate:
                    '新しいアプリを作成し、名前を{{appName}}にして、上記のMCPエンドポイントをURLに貼り付けます。認証方式はOAuthを選択します — クライアントIDやシークレットは不要です。',
                chatgptStepConnect: 'アプリを接続し、{{appName}}アカウントでサインインします。',
                chatgptStepUse: 'チャットで「+」メニューから{{appName}}を追加すると、ChatGPTが使えるようになります。',
                openEditorNote: 'まずエディタでこの編み図を開いてください — AIは現在開いている編み図のみ編集できます。',
                reconnectNote:
                    '以前クライアントIDを使って{{appName}}を設定した場合は、その接続を削除し、上記の手順で追加し直してください。クライアントIDは今後使用されません。',
                privacyNote: 'AIはあなたとして操作し、あなたの編み図のみを対象とします。他の人の作品には一切触れません。',
                signInPrompt: 'AIアシスタントと連携するにはサインインしてください。',
            },
        },

        hotkeysReference: {
            title: 'ショートカット',
            description: '現在使用中のキーボードショートカットの一覧です。エディタごとに分類されています。',
            groups: {
                global: '全般',
                crochet: 'かぎ針エディター',
                annotation: '注釈レイヤー',
                grid: '棒針エディター',
                composer: 'パターンエディター',
            },
            keys: {
                space: 'スペース',
                drag: 'ドラッグ',
                scroll: 'スクロール',
                ctrl: 'Ctrl',
                enter: 'Enter',
                esc: 'Esc',
                delete: 'Delete',
                backspace: 'Backspace',
                hold: '長押し',
                doubleClick: 'ダブルクリック',
                arrows: '↑ ↓ ← →',
                shift: 'Shift',
                dragCorner: 'コーナーハンドルをドラッグ',
                dragEdge: 'エッジハンドルをドラッグ',
                dragHandle: '回転ハンドルをドラッグ',
                dragDraw: '線ツールでクリックしてドラッグ',
                dragAnchor: 'アンカーハンドルをドラッグ',
                cmd: 'Cmd',
                pinch: 'ピンチ',
                middleDrag: '中ボタンでドラッグ',
                pageUp: 'Page Up',
                pageDown: 'Page Down',
            },
            global: {
                save: '保存',
                commandPalette: 'コマンドパレットを開く',
                pan: 'キャンバスを移動',
                zoom: 'ズーム',
                layerStitch: 'ステッチレイヤーに切り替え',
                layerAnnotation: '注釈レイヤーに切り替え',
            },
            crochet: {
                undo: '元に戻す',
                redo: 'やり直す',
                copy: 'コピー',
                paste: 'ポインタ位置に貼り付け',
                pasteWithStitches: 'ガイドをスナップ済みの編み目と一緒に貼り付け',
                pasteWithStructure: 'ガイドを編み目の構造ごと貼り付け',
                duplicate: '複製',
                delete: '選択項目を削除',
                grab: '選択項目を移動（グラブ）',
                grabAxis: 'グラブを X / Y 軸にロック',
                slide: 'ガイドに沿ってスライド',
                slideRigid: '形を保ったままスライド',
                extend: '選択範囲を広げる',
                extendCoarse: '選択範囲を広げる（大きく）',
                shrink: '選択範囲を狭める',
                shrinkCoarse: '選択範囲を狭める（大きく）',
                nudge: '選択項目を少し移動',
                nudgeCoarse: '選択項目を大きく移動',
                fillGuide: 'ガイド全体に合わせて幅を調整',
                alignToNormal: '選択範囲を法線方向に整列',
                alignRadially: '選択範囲を放射状に整列',
                flipHorizontal: '選択した項目を左右反転',
                flipVertical: '選択した項目を上下反転',
                toolToggle: '編み目／ガイドツールを切り替え',
                handleType: 'ベジェハンドルの種類を切り替え',
                link: 'リンクモードを切り替え',
                snap: 'グリッドスナップを切り替え',
                scopeBases: 'ベースのみ選択',
                scopeTops: 'トップのみ選択',
                pieMenu: 'パイメニューを開く',
                quickAccess: 'クイックアクセスを開く',
                commit: '操作を確定',
                cancel: '操作をキャンセル',
                editGuide: 'ガイドの形を編集（ガイドツール）',
                exitGuideEdit: 'ガイドの形の編集を終了',
                propertiesPanel: 'プロパティパネルを表示／隠す',
            },
            annotation: {
                delete: '選択した注釈を削除',
                duplicate: '選択した注釈を複製',
                copy: '選択した注釈をコピー',
                paste: 'ポインター位置に注釈を貼り付け',
                selectAll: 'すべての注釈を選択',
                nudge: '選択した注釈を少し移動',
                nudgeCoarse: '選択した注釈を大きく移動',
                cancel: '配置または操作をキャンセル',
                scale: '選択した注釈のサイズを変更',
                stretch: '選択した注釈を一方向に伸縮',
                rotate: '選択した注釈を回転',
                drawLine: '接続線を描画',
                moveAnchor: '線のアンカーを移動',
                editCurve: '図形またはラベルを編集（曲線、円、円弧、テキスト）',
                cycleHandle: 'ハンドルタイプを切り替え',
            },
            grid: {
                undo: '元に戻す',
                redo: 'やり直す',
                copy: 'コピー',
                paste: '貼り付け',
                modeToggle: '編み目／マス目モードを切り替え',
                grab: '選択項目を移動（グラブ）',
                pieMenu: 'パイメニューを開く',
                cancel: '操作をキャンセル',
            },
            composer: {
                deleteElement: '選択した要素を削除',
                deselect: '選択を解除',
                bold: '太字（テキスト）',
                italic: '斜体（テキスト）',
                underline: '下線（テキスト）',
                undo: '元に戻す',
                redo: 'やり直す',
                textUndo: '入力中の元に戻す',
                textRedo: '入力中のやり直し',
                zoomIn: '拡大',
                zoomOut: '縮小',
                fitPage: 'ページ全体を表示',
                zoom: 'ズーム',
                pan: 'キャンバスを移動',
                panScreen: '1 画面スクロール',
                panArrows: 'スクロール（何も選択していないとき）',
            },
        },

        commandPalette: {
            placeholder: 'エディター機能を検索…',
            empty: '一致する機能はありません',
            howTo: '使い方',
            descriptions: {
                global: {
                    pan: 'スペースキーを押しながらドラッグ、またはスクロールしてキャンバス上を移動します。',
                    zoom: 'Ctrl を押しながらスクロールすると拡大・縮小します。',
                },
                crochet: {
                    paste: '先にコピーしてから貼り付けのショートカットを押します。編み目はマウスポインターの位置に配置されます。',
                    pasteWithStitches: 'ガイドツールでガイドをコピーした後、このショートカットでガイドにスナップしている編み目も一緒に貼り付けます。',
                    pasteWithStructure: '「スナップ済みの編み目と一緒に貼り付け」と同じですが、その上に編まれた段もまとめて運びます。',
                    grab: '編み目を選択して G を押し、マウスを動かしてからクリックするか、もう一度 G を押して置きます。',
                    grabAxis:
                        'G でグラブ中に X を押すと水平方向にのみ、Y を押すと垂直方向にのみ移動します。同じキーをもう一度押すとロックを解除します。緑色（X）または赤色（Y）の線がロック中の軸を示します。',
                    slide: 'ガイド上の編み目を選択して C を押すとガイドに沿ってスライドします。クリックで置きます。',
                    slideRigid: 'スライドと同じですが、Shift+C では編み目の間隔を保ったままスライドします。',
                    extend: '選択中に ] を押すと、ガイドに沿って 1 目分伸ばします。',
                    extendCoarse: 'Shift+] では選択範囲をより大きく伸ばします。',
                    shrink: '選択中に [ を押すと 1 目分縮めます。',
                    shrinkCoarse: 'Shift+[ では選択範囲をより大きく縮めます。',
                    nudge:
                        '矢印キーを押すと、選択した編み目（ガイドツール使用時は選択したガイド）を1ピクセル移動します。ガイドにスナップしているハンドルや別の編み目に接続されているハンドルは動きません。そのような編み目を少し移動するには、自由に動かせるハンドルだけを選択してください。',
                    nudgeCoarse: 'Shift + 矢印キーで選択項目を10ピクセル移動します。',
                    scopeBases: 'B を押しながらクリックすると、編み目のベースだけを選択します。',
                    scopeTops: 'T を押しながらクリックすると、編み目のトップだけを選択します。',
                    pieMenu: 'S を長押しするとポインター位置にパイメニューが開き、項目の上で離すと確定します。',
                    quickAccess:
                        'W キーを押すと、ポインターの位置にクイックアクセスメニューが開きます。操作を追加するには、編み目の右クリックメニューか、この検索結果で項目を右クリックしてください。',
                    commit: 'Enter を押すと、保留中の増し目・減らし目・ガイド編集を確定します。',
                    cancel: 'Esc を押すと、保留中の操作や選択フローをキャンセルします。',
                    editGuide: 'ガイドツールでガイドを 1 つ選択し、Enter を押す（またはダブルクリック）と形状を編集できます。',
                    exitGuideEdit: 'Esc を押すとガイドの形状編集を終了します。',
                },
                annotation: {
                    paste: '注釈レイヤーで、まずマーカーをコピーしてから貼り付けのショートカットを押すと、マウスポインターの位置に配置されます。',
                    nudge: '注釈レイヤーでマーカーを選択し、矢印キーを押すと1ピクセル移動します。',
                    nudgeCoarse: 'Shift + 矢印キーで、選択したマーカーを10ピクセル移動します。',
                    cancel: 'Esc を押すと、配置待ちのマーカーを解除するか、ドラッグ／回転を中止します。',
                    scale: '注釈レイヤーでマーカーを選択し、4つのコーナーハンドルのいずれかをドラッグします。マーカーは中心を基準に縦横比を保ったまま拡大／縮小されます。',
                    stretch: '4つのエッジハンドルのいずれかをドラッグすると、その方向にのみマーカーを伸縮できます。コーナーをドラッグした場合は縦横比が保たれます。',
                    rotate: 'マーカーを選択し、前方にある丸いハンドルをドラッグして新しい方向に向けます。',
                    drawLine:
                        '左側のバーで「線」を選び、キャンバス上で押して反対側の端までドラッグします。編み目の近くにある端点はその編み目にスナップし、編み目の移動に追従します。',
                    moveAnchor: '線を選択し、丸いアンカーハンドルのいずれかをドラッグします。編み目の上で放すと、その編み目に接続されます。',
                    editCurve:
                        '曲線、円、円弧、またはテキストラベルを選択して Enter を押すと（またはダブルクリックするか、インスペクターの「図形を編集」ボタンを使用すると）、ハンドルが表示されます。テキストラベルの場合は文字入力を開始します。',
                    cycleHandle: '曲線の編集中にハンドルを選択して T を押すと、タイプが「整列」「ベクトル」「フリー」の順に切り替わります。',
                },
                grid: {
                    grab: 'セルを選択して G を押し、マウスを動かしてからクリックするか、もう一度 G を押して置きます。',
                    pieMenu: 'S を長押しするとポインター位置にパイメニューが開き、項目の上で離すと確定します。',
                    cancel: 'Esc を押すと現在の操作をキャンセルします。',
                },
            },
        },

        consent: {
            banner: {
                title: 'Cookie を使用しています',
                description:
                    '{{appName}} はアプリの利用状況を把握し改善するために分析 Cookie を使用します。すべて許可、拒否、またはカテゴリーを選択できます。',
                acceptAll: 'すべて許可',
                rejectAll: 'すべて拒否',
                customize: 'カスタマイズ',
                save: '選択を保存',
                privacyLink: 'プライバシーと Cookie',
            },
            categories: {
                analytics: {
                    label: '分析',
                    description: 'アプリ改善に役立つ利用イベントと自動操作キャプチャ。',
                },
                sessionReplay: {
                    label: 'セッションリプレイ',
                    description: '問題診断のため匿名化されたセッションを記録します。分析より詳細です。',
                },
                errorMonitoring: {
                    label: 'エラー監視',
                    description: 'クラッシュレポートとパフォーマンスデータを Sentry に送信し、問題の発見と修正に役立てます。',
                },
            },
            settings: {
                navLabel: 'プライバシーと Cookie',
                title: 'プライバシーと Cookie',
                description: '{{appName}} が使用できる分析 Cookie を管理します。保存するとページが再読み込みされ、選択が適用されます。',
                viewPolicy: 'プライバシーと Cookie ページを表示',
            },
            privacyPage: {
                title: 'プライバシーと Cookie',
                intro:
                    '{{appName}} は以下の目的で Cookie および類似技術（ブラウザのローカルストレージを含む）を使用します。必須項目は常に有効です。分析とセッションリプレイは同意がある場合にのみ実行され、いつでも変更できます。',
                manage: 'Cookie 設定を管理',
                policy: {
                    updated: '最終更新日：{{date}}',
                    whoWeAre: {
                        p1:
                            '{{appName}} は Kinnet Studio（以下「当方」）が運営する編み物・かぎ針編みのパターンデザインアプリです。本プライバシーポリシーでは、{{appName}} のご利用にあたり当方が収集する個人データ、その利用方法、共有先、およびお客様の選択肢について説明します。本ポリシーは英語版を正本とします。',
                        contact: 'プライバシーに関するお問い合わせ：',
                    },
                    dataWeCollect: {
                        title: '収集するデータ',
                        p1:
                            'アカウント情報。アカウント作成時に、認証プロバイダーである Clerk を通じてメールアドレス、表示名、プロフィール画像を受け取ります。Google などの第三者プロバイダーでサインインする場合、これらの基本的なプロフィール情報がそのプロバイダーから当方に共有されます。当該プロバイダーのパスワードを当方が受け取ることはありません。',
                        p2:
                            'お客様のコンテンツ。作成したパターン、チャート、編み図は、端末間で同期し、選択した場合に他の人と共有できるよう、当方のサーバーに保存されます。',
                        p3:
                            '利用状況・診断データ（任意）。同意がある場合に限り、アプリの利用状況の把握と問題の修正のため、分析イベント、匿名化されたセッションリプレイ、エラーレポートを収集します。これらは既定で無効であり、Cookie バナーまたは設定から管理できます。',
                        p4: '端末の設定。言語、フォントサイズ、ステッチカラーなどの設定はブラウザのローカルにのみ保存され、当方に送信されることはありません。',
                    },
                    googleUserData: {
                        title: 'Google ユーザーデータ',
                        p1:
                            'Google でサインインする場合、{{appName}} が受け取るのは、認証プロバイダーである Clerk を通じた基本的な Google プロフィール情報（氏名、メールアドレス、プロフィール画像）のみです。Gmail、ドライブ、連絡先など、その他の Google サービスやデータへのアクセスを要求することはありません。',
                        p2: 'これらの情報は、{{appName}} アカウントの作成と保護、アプリ内でのお客様の識別、およびサービスに関する連絡のためにのみ使用します。',
                        p3:
                            '当方が Google ユーザーデータを販売したり、広告に利用したり、下記のサービスプロバイダー以外の第三者と共有することはありません。これらのプロバイダーは {{appName}} の運営のため、当方に代わってデータを処理します。',
                    },
                    howWeUse: {
                        title: 'データの利用方法',
                        p1:
                            'お客様のデータは {{appName}} の提供のために使用します。具体的には、認証、パターンの保存と同期、およびお客様が選択した共有機能の提供です。',
                        p2:
                            '同意がある場合には、集計された利用状況データとエラーレポートをアプリの改善にも使用します。個人データを販売したり、第三者広告に利用したりすることはありません。',
                    },
                    processors: {
                        title: 'サービスプロバイダー',
                        intro:
                            '{{appName}} の運営には以下のサービスプロバイダーを利用しています。各プロバイダーは当方に代わり、そのサービスの提供に必要な範囲でのみデータを処理します：',
                        items: {
                            clerk: 'Clerk——認証とアカウント管理（メールアドレス、氏名、プロフィール画像、サインイン状態）。',
                            cloudflare: 'Cloudflare——アプリケーションのホスティングと同期コンテンツの保存。',
                            statsig: 'Statsig——プロダクト分析とセッションリプレイ。同意がある場合のみ有効。',
                            sentry: 'Sentry——クラッシュおよびエラーレポート。同意がある場合のみ有効。',
                            userback: 'Userback——フィードバック収集。フィードバックフォームを開いたときのみ読み込まれます。',
                            google: 'Google——サインインのみ（Google でのサインインを選択した場合）。',
                        },
                    },
                    retention: {
                        title: 'データの保持と削除',
                        p1:
                            'アカウントが存在する限り、アカウントデータとコンテンツを保持します。アカウントを削除すると、アカウントデータと同期コンテンツは当方のシステムから削除されます。バックアップ内の残存コピーは通常のローテーションに従って削除されます。',
                        p2: '上記のメールアドレスへのご連絡により、アカウントとデータの削除、または当方が保有するお客様のデータの写しを、いつでも請求できます。',
                    },
                    cookies: {
                        title: 'Cookie とローカルストレージ',
                    },
                    yourRights: {
                        title: 'お客様の権利と選択肢',
                        p1:
                            '上記または設定内の「Cookie 設定を管理」ボタンから、分析、セッションリプレイ、エラー監視への同意をいつでも撤回・変更できます。同意を撤回すると、以後の収集は停止されます。',
                        p2:
                            'お住まいの地域によっては、個人データへのアクセス、訂正、エクスポート、削除の権利を有する場合があります。上記のメールアドレスまでご連絡いただければ、これらの請求に対応します。',
                    },
                    changes: {
                        title: '本ポリシーの変更',
                        p1:
                            '{{appName}} の発展に伴い、本ポリシーを更新することがあります。重要な変更はアプリ内でお知らせし、上記の「最終更新日」は常に現行バージョンを反映します。',
                    },
                },
                table: {
                    name: '名称',
                    purpose: '目的',
                    storage: '保存先',
                },
                storageType: {
                    cookie: 'Cookie',
                    local: 'ローカルストレージ',
                    network: 'Sentry に送信',
                },
                cat: {
                    necessary: {
                        title: '必須',
                        desc: 'サインインとアプリの動作に必要で、認証プロバイダー（Clerk）が提供します。無効にできません。',
                    },
                    functional: {
                        title: '機能設定',
                        desc: 'この端末での設定を記憶します。ファーストパーティのみで、トラッキングはありません。',
                    },
                    analytics: {
                        title: '分析',
                        desc: '利用状況の把握とアプリ改善に役立ちます。分析プロバイダー（Statsig）経由。同意がある場合のみ有効です。',
                    },
                    replay: {
                        title: 'セッションリプレイ',
                        desc: '問題診断のため匿名化されたセッションを記録します。Statsig 経由。同意がある場合のみ有効です。',
                    },
                    errorMonitoring: {
                        title: 'エラー監視',
                        desc:
                            '問題の修正のため、クラッシュレポートとパフォーマンスデータを取得します。監視プロバイダー（Sentry）経由。永続的な Cookie は設定せず、データはネットワーク経由で送信されます。同意がある場合のみ有効です。',
                    },
                },
                purpose: {
                    clerkSession: 'サインイン状態を維持します（認証）。',
                    clerkUat: 'ページのルーティング用にサインイン状態を追跡します。',
                    consent: 'Cookie の選択を記憶します。',
                    lang: '言語の設定。',
                    fontSize: 'インターフェースのフォントサイズ設定。',
                    bentoRadius: 'エディターパネルの角丸設定。',
                    cursor: 'カスタムカーソルの有効・無効。',
                    colors: '保存したカスタムステッチカラー。',
                    featureGates: '読み込み中にちらつかないよう、オンになっているアプリの機能を記憶します。',
                    statsigStable: '分析用の匿名デバイス識別子。',
                    statsigSession: '分析イベントをセッションにまとめます。',
                    statsigCache: 'キューに入った分析イベントとキャッシュされた構成。',
                    replay: '匿名化されたセッションリプレイ記録をバッファします。',
                    sentryDiagnostics: 'Sentry に送信されるクラッシュレポートとパフォーマンス・プロファイリングデータ。',
                },
            },
        },

        authFooter: {
            privacy: 'プライバシーポリシー',
            terms: '利用規約',
            licenses: 'ライセンス',
        },

        authSiteLinks: {
            label: '{{appName}} ウェブサイト',
            prompt: '{{appName}}は初めてですか？',
            landing: '機能を見る',
            blog: 'ブログを読む',
        },

        unproofreadTranslationNotice: {
            message: '日本語の翻訳はまだ校正されていません。ご自身の判断でご利用ください。現在、校正を進めています。',
            close: '閉じる',
            languageOptionHint: '翻訳は未校正です',
        },

        whatsNew: {
            title: '新機能',
            description: '{{appName}} の最新の改善点です。',
            unreadHint: '新しいお知らせがあります',
            menuLabelUnread: 'ナビゲーションメニューを開く（新しいお知らせあり）',
            titleUnread: '新機能（新しいお知らせあり）',
            openAsPage: 'ページで開く',
            empty: 'リリースノートはまだありません。',
            loading: '読み込み中…',
            loadError: 'リリースノートを読み込めませんでした。',
            retry: '再試行',
            languageFallback: '{{language}}版はまだないため、英語で表示しています。',
        },

        terms: {
            title: '利用規約',
            updated: '最終更新日：{{date}}',
            intro: {
                p1:
                    '本利用規約は、編み物・かぎ針編みのパターンデザインアプリ {{appName}} の運営者である Kinnet Studio（以下「当方」）とお客様との間の合意です。アカウントを作成し、または {{appName}} を利用することにより、お客様は本規約に同意したものとみなされます。同意いただけない場合は、本サービスをご利用にならないでください。本規約は英語版を正本とします。',
                contact: '本規約に関するお問い合わせ：',
            },
            sections: {
                account: {
                    title: 'お客様のアカウント',
                    p1:
                        'お客様は、当方の認証プロバイダーである Clerk を通じて {{appName}} にサインインします。サインイン情報は安全に管理してください。アカウント下で行われる活動については、お客様が責任を負います。',
                    p2: '{{appName}} のご利用には、13 歳以上である必要があります。',
                },
                yourContent: {
                    title: 'お客様のコンテンツ',
                    p1: 'お客様が作成したパターン、チャート、編み図はお客様に帰属します。本規約により、お客様のコンテンツの所有権が当方に移転することはありません。',
                    p2:
                        '{{appName}} の運営のため、お客様は当方に対し、コンテンツをホスト、保存、複製、表示するための全世界的かつ非独占的なライセンスを付与します。これは、端末間の同期やお客様が有効にした共有機能を含め、本サービスの提供に必要な範囲に限られます。',
                },
                acceptableUse: {
                    title: '適切な利用',
                    p1:
                        '{{appName}} は適法な目的にのみご利用ください。他者の権利を侵害するコンテンツをアップロードしたり、本サービスを利用して誰かに嫌がらせや危害を加えたりしないでください。',
                    p2:
                        '本サービスへの妨害や混乱を引き起こす行為、自分のものではないアカウントやデータへのアクセスの試み、当方が提供するインターフェース以外の自動化された手段によるスクレイピングやアクセスは行わないでください。',
                },
                service: {
                    title: '本サービス',
                    p1: 'サービスの発展に伴い、当方は {{appName}} の機能を追加・変更・削除することがあります。',
                    p2: '当方は、本サービスの全部または一部をいつでも変更、停止、終了することがあります。',
                },
                ip: {
                    title: '当方の知的財産',
                    p1:
                        '{{appName}} アプリケーションおよびそのデザイン、名称、ブランドは当方に帰属します。本規約は、本サービスの利用を超えるいかなる権利もお客様に付与するものではありません。お客様のコンテンツはお客様のものです（「お客様のコンテンツ」参照）。',
                },
                termination: {
                    title: '解約と譲渡',
                    p1: 'お客様はいつでも {{appName}} の利用をやめ、アカウントを削除できます。データの削除はプライバシーポリシーに従います。',
                    p2: 'お客様が本規約に違反した場合、当方はアカウントを停止または解約することがあります。',
                    p3:
                        '当方は、組織再編またはサービスの移転に伴い、本規約および本規約に基づく合意を承継者または関連会社に譲渡することがあります。本規約に基づくお客様の権利はお客様個人に帰属し、譲渡することはできません。',
                },
                disclaimers: {
                    title: '免責事項',
                    p1:
                        '法律で認められる最大限の範囲において、{{appName}} は「現状有姿」かつ「提供可能な限度」で提供され、特定目的への適合性や中断・エラーのない動作を含め、明示または黙示を問わずいかなる保証も行いません。',
                },
                liability: {
                    title: '責任の制限',
                    p1:
                        '法律で認められる最大限の範囲において、本サービスに起因または関連する請求に対する当方の責任の総額は、請求発生前 12 か月間にお客様が本サービスに対して当方に支払った金額を上限とします。データの損失を含め、間接損害、付随的損害、結果的損害について当方は責任を負いません。',
                },
                law: {
                    title: '準拠法',
                    p1: '本規約は台湾（中華民国）の法律に準拠し、本規約または {{appName}} の利用から生じる紛争は、台湾の裁判所に付託されるものとします。',
                },
                changes: {
                    title: '本規約の変更',
                    p1:
                        '{{appName}} の発展に伴い、本規約を更新することがあります。上記の「最終更新日」は常に現行バージョンを反映しますので、本ページを随時ご確認ください。変更の発効後も本サービスの利用を継続した場合、更新後の規約に同意したものとみなされます。',
                },
            },
        },

        waitlist: {
            heading: '{{appName}} は招待制です',
            subtext: '順番待ちリストに登録すると、空きが出次第メールでお知らせします。',
        },

        contextMenu: {
            atCell: 'セル（行 {{row}} ・ 列 {{col}}）',
            selectionArea: '選択: {{rowCount}} 行 × {{colCount}} 列（行 {{r1}}–{{r2}} ・ 列 {{c1}}–{{c2}}）',
            copyPattern: '模様をコピー',
            pastePattern: '模様を貼り付け',
            clipboardLoading: 'クリップボード: 確認中…',
            clipboardEmpty: 'クリップボード: 空',
            clipboardHasPattern: 'クリップボード: エディタの模様あり',
            clipboardHasOther: 'クリップボード: 他の文字あり',
            clipboardUnavailable: 'クリップボード: 読み取れません（権限やブラウザ）',
            copyReplacesClipboard: 'コピーすると現在のクリップボードの内容が上書きされます。',
            fillRange: '選択範囲を現在の目で塗りつぶす',
            fillColorRange: '選択範囲を現在の色で塗る',
            clearRange: '選択範囲のマスを空にする',
            placeCellHere: 'ここにセルを配置',
            startNewPieceHere: 'ここから新しいピースを開始',
            removeCellHere: 'セルを削除',
        },

        // Toolbar
        toolbar: {
            placeTool: '配置',
            placeToolDescription: 'マス上に目を置く',
            selectTool: '選択',
            selectToolDescription: 'マスを選択。ドラッグで範囲。Shift+クリックで直近アンカーから拡大',
            prependRow: '上に {{count}} 行を挿入',
            appendRow: '下に {{count}} 行を追加',
            removeFirstRow: '先頭の {{count}} 行を削除',
            removeLastRow: '末尾の {{count}} 行を削除',
            prependColumn: '左に {{count}} 列を挿入',
            appendColumn: '右に {{count}} 列を追加',
            removeFirstColumn: '先頭の {{count}} 列を削除',
            removeLastColumn: '末尾の {{count}} 列を削除',
            stitchPicker: 'ステッチを選択',
            eraseTool: '消去',
            eraseToolDescription: 'マスから目を消す',
            stitchColor: '目の色',
            stitchColorStandard: '標準',
            stitchColorCustomHint: 'カスタム（スウォッチを右クリックで変更）',
            stitchColorCustomSlot: 'カスタムスロット {{n}}',
            stitchColorEditingSlot: 'スロット {{n}} を編集中',
            stitchColorBack: 'スウォッチに戻る',
            stitchColorHue: '色相',
            stitchColorSaturation: '彩度と明度',
            stitchColorHex: '16 進カラーコード',
            stitchMode: '編み目モード',
            cellMode: 'セルモード',
            stitchModeShort: '編み目',
            cellModeShort: 'セル',
            cellModeDescription: '形を編集：チャートのセルを追加・削除',
            stitchModeDescription: '既存のセルに編み目を配置',
            inputMode: {
                mouse: 'マウス',
                trackpad: 'トラックパッド',
                switchToTrackpad: 'パンとズームにキーボードとマウスを使用中。クリックでトラックパッドに切り替えます。',
                switchToMouse: 'パンとズームにトラックパッドを使用中。クリックでキーボードとマウスに切り替えます。',
            },
        },

        export: {
            button: '範囲を書き出し',
            panelTitle: '書き出しオプション',
            dragHint: '書き出す範囲をドラッグしてください（Esc でキャンセル）',
            includeGrid: '背景グリッド',
            includeGuides: 'ガイド',
            includeLabels: '行・列ラベル',
            includeLabelsCrochet: '段・順番ラベル',
            transparent: '背景を透過',
            quality: '画質',
            cancel: 'キャンセル',
            download: 'PNG をダウンロード',
            exporting: '書き出し中…',
            failed: '書き出しに失敗しました。もう一度お試しください。',
        },

        diagramEmbed: {
            title: '編み図を挿入',
            frameTitle: '編み図の範囲指定',
            loading: '編み図を読み込み中…',
            noDiagrams: '保存された編み図がありません。',
            kindCrochet: 'かぎ針',
            kindKnitting: '棒針',
            use: 'この範囲を使用',
            refresh: '編み図から更新',
            tooLarge: '範囲が大きすぎて挿入できません。画質を下げるか、範囲を狭めてください。',
            renderFailed: '編み図を書き出せませんでした。もう一度お試しください。',
            insertFailed: '編み図を挿入できませんでした。もう一度お試しください。',
            emptyDiagram: 'この編み図は空です — 挿入するものがありません。',
            diagramUnavailable: 'この編み図は利用できなくなりました。',
            frameTimeout: '編み図ビューアを読み込めませんでした。もう一度お試しください。',
        },

        strokeStyle: {
            label: '線',
            width: '太さ',
            cap: {
                label: '線端',
                round: '丸',
                square: '角',
                butt: '平',
            },
            inherited: '編み図の既定',
            mixed: '混在',
            resetToDiagram: '編み図の設定に戻す',
            resetToFactory: 'リセット',
            widthValue: '{{value}}×',
        },

        crochetInspector: {
            ringHeading: 'リング',
            lineGuideHeading: '直線ガイド',
            circleGuideHeading: '円ガイド',
            centerSymbolLabel: '中心の記号',
            centerSymbol: {
                none: 'なし',
                'magic-ring': 'マジックリング',
                wa: 'わ',
            },
            bezierGuideHeading: 'ベジェ曲線ガイド',
            bezierClose: 'ループを閉じる',
            bezierOpen: '曲線を開く',
            bezierAddAnchor: 'アンカーを追加',
            bezierRemoveAnchor: 'アンカーを削除',
            bezierAnchorHandles: '選択アンカーのハンドル',
            bezierHandle_aligned: '整列',
            bezierHandle_vector: 'ベクトル',
            bezierHandle_free: 'フリー',
            bezierHandleSide_left: '左',
            bezierHandleSide_right: '右',
            tbcHeading: '目',
            tbcsHeading: '目',
            panelTitle: 'インスペクター',
            emptyState: '目やガイドを選択するとプロパティが表示されます。',
            collapse: 'パネルを折りたたむ',
            expand: 'パネルを展開',
            close: 'パネルを閉じる',
            groupOrder: {
                title: 'グループの重なり順',
                flip: '前後を入れ替え',
                ungroup: 'グループ化を解除',
                detachMember: 'グループから分離',
                bringToFront: '最前面へ移動',
                bringForward: '前面へ移動',
                sendBackward: '背面へ移動',
                sendToBack: '最背面へ移動',
            },
            perTopHeading: '各トップ',
            roundLabel: '段／周',
            ringRadius: '半径: {{radius}}',
            setAllTops: 'すべてのトップに適用',
            multiSelected: '{{count}} 個の目を選択中',
            editShape: '形を編集',
            guidesSelected: '{{count}} 個のガイドを選択中',
            setRoundForSelection: 'すべての目の段／周を設定',
            clearRound: 'クリア',
            topUserRoundLabel: '上書き',
            orderLabel: '順序',
            setOrderForSelection: 'すべての目の順序を設定',
            orderNoRound: '段未設定',
            sourceMixed: '混在',
            sourceFree: 'なし',
            sourceDisagreement: '不一致',
            sourceCycle: '循環',
            source: {
                user: 'ユーザー',
                guide: '案内線',
                inferred: '推測',
            },
            verticalLinksTitle: '垂直リンク',
            verticalParentsLabel: '親目',
            verticalChildrenLabel: '子目',
            verticalNoLinks: '垂直リンクなし',
            verticalUnlink: 'リンクを解除',
            verticalShowOnCanvas: '表示',
            verticalHideOnCanvas: '非表示',
            verticalLegendParent: '親側',
            verticalLegendChild: '子側',
            verticalIssueRoundOrder: '親目の段が子目より後です',
            verticalIssueMixed: '端点の段が一つに定まりません',
            spaceTitle: '空間',
            spaceChainCount: '鎖 {{n}} 目の空間',
            spaceNoGuide: '拾うガイドなし',
            spaceGuideLabel: 'ガイド',
            spaceSetGuide: '拾うガイドを設定…',
            spaceClearGuide: 'ガイドを解除',
            spaceDissolve: '空間を解除',
            spaceGuideTaken: 'そのガイドはすでに別の空間の対象です。',
            spaceGuideChainSnapped: 'この空間の鎖目がそのガイドにスナップしているため、拾うガイドに設定できません。',
            sectionRoundOrder: '段と順序',
            sectionColor: '色',
            colorMixed: '複数の色',
            sectionFollowTangent: 'ガイドの接線',
            followTangent: {
                label: 'ガイドの接線に追従',
                hint: '追従中はキャップ角度が固定されます。',
                on: 'オン',
                off: 'オフ',
                mixed: '混在',
            },
            rectSizeHeading: 'サイズ',
            rectWidthLabel: '幅',
            rectHeightLabel: '高さ',
            rectSizeValue: '{{value}}×',
            rectSizeMixed: '混在',
            rectHeightPinned: '両端がガイドに接続されているため、高さは固定されています。片方を切り離すとサイズを変更できます。',
            cluster: {
                memberType: '構成する編み目',
                count: '本数',
                countMinus: '玉編みの本数を減らす',
                countPlus: '玉編みの本数を増やす',
                into: {
                    label: '編み入れ方',
                    stitch: '挑針（針に編み入れ）',
                    space: '挑束（束に編み入れ）',
                },
            },
            popcorn: {
                memberType: '構成する編み目',
                count: '本数',
                countMinus: 'ポップコーン編みの本数を減らす',
                countPlus: 'ポップコーン編みの本数を増やす',
                into: {
                    label: '編み入れ方',
                    stitch: '挑針（針に編み入れ）',
                    space: '挑束（束に編み入れ）',
                },
            },
        },

        propertiesColumn: {
            collapse: 'パネルを隠す',
            resize: 'パネル幅を調整',
            expand: 'パネルを表示',
        },

        headerTray: {
            collapse: 'ヘッダーを隠す',
            expand: 'ヘッダーを表示',
        },

        commandKeyToggle: {
            label: '選択に追加',
            tooltipOn: '選択に追加がオン — 項目をタップで追加/解除、ドラッグで範囲を反転します。タップでオフ。',
            tooltipOff: '選択に追加 — 項目をタップで追加/解除、ドラッグで範囲を反転します。',
        },

        altKeyToggle: {
            label: 'Alt 操作',
            tooltipOn: 'Alt 操作がオン — スナップ済みハンドルをタップで選択対象を切り替え、編み目本体をタップで全ハンドルを選択します。タップでオフ。',
            tooltipOff: 'Alt 操作 — スナップ済みハンドルをタップで選択対象を切り替え、編み目本体をタップで全ハンドルを選択します。',
        },

        crochetStepper: {
            extend: '長くする',
            shrink: '短くする',
        },

        quickAccess: {
            title: 'クイックアクセス',
            empty: 'メニュー項目を右クリックすると、ここに追加できます。',
            add: 'クイックアクセスに追加',
            remove: 'クイックアクセスから削除',
        },

        crochetContextMenu: {
            addRingAbove: '上にリングを追加',
            addRingBelow: '下にリングを追加',
            finishPlacement: '完了',
            cancelPlacement: 'キャンセル',
            removeRing: 'リングを削除',
            deleteGuide: 'ガイドを削除',
            addStitchesAlongGuide: '編み目を追加…',
            selectAllHandlesOnGuide: 'すべてのハンドルを選択',
            selectAllTopsOnGuide: 'すべてのトップを選択',
            selectAllBasesOnGuide: 'すべてのベースを選択',
            doneEditing: '編集を終了',
            editBezier: 'ベジェ曲線を編集',
            distributeBasesEvenly: 'ベースを均等に分布',
            distributeTopsEvenly: 'トップを均等に分布',
            distributeBothEvenly: '両方を均等に分布',
            spreadBasesAcrossGuide: 'ベースをガイド上に広げる…',
            spreadTopsAcrossGuide: 'トップをガイド上に広げる…',
            spreadBasesBetweenPoints: '2 点間にベースを分散配置…',
            spreadTopsBetweenPoints: '2 点間にトップを分散配置…',
            spreadBetweenPointsHintStart: '開始するにはガイド上の点をクリックしてください。編み目をクリックすると、その横で停止します。',
            spreadBetweenPointsHintEnd: '分散範囲の終点をクリックしてください。',
            projectBasesOntoGuide: 'ベースをガイドに投影…',
            projectTopsOntoGuide: 'トップをガイドに投影…',
            projectBothOntoGuide: '両方をガイドに投影…',
            slideAlongGuide: 'ガイドに沿ってスライド',
            slideAlongGuideKeepOrientation: 'ガイドに沿ってスライド（向きを維持）',
            distributeSnappedBasesBetween: 'スナップしたベースを端点間に分布',
            distributeSnappedTopsBetween: 'スナップしたトップを端点間に分布',
            distributeSnappedBothBetween: 'スナップしたベースとトップを端点間に分布',
            rewidthToFillGuide: 'ガイドに合わせて幅を調整',
            alignRadially: '放射状に整列',
            alignRadiallyToBase: 'ベース基準で放射状に整列',
            alignRadiallyToTop: 'トップ基準で放射状に整列',
            alignToNormal: '法線方向に整列',
            alignToBaseNormal: 'ベースの法線方向に整列',
            alignToTopNormal: 'トップの法線方向に整列',
            alignDirection: '方向を整列',
            guide: 'ガイド',
            detach: '分離',
            link: 'リンク',
            align: '整列',
            horizontal: '水平',
            vertical: '垂直',
            top: '上',
            bottom: '下',
            left: '左',
            right: '右',
            distribute: '分布',
            horizontally: '水平に分布',
            vertically: '垂直に分布',
            addStitchOnTop: 'トップに目を追加…',
            addIncreaseOnTop: 'トップに増し目を追加…',
            addStitchUnder: '下側に目を追加…',
            addIncreaseUnder: '下側に増し目を追加…',
            singleCrochet: '細編み',
            nTops: '{{count}} 個のトップ',
            resetGap: '間隔をリセット',
            detachFromParent: '親から分離',
            detachFromParents: '親から分離（{{count}} 個）',
            breakConnectionHere: 'ここで接続を切断',
            detachHandleFromGuide: 'ガイドからハンドルを分離',
            detachHandlesFromGuides: 'ガイドから {{count}} 個のハンドルを分離',
            detachBaseFromGuide: 'ガイドからベースを分離',
            detachBasesFromGuides: 'ガイドから {{count}} 個のベースを分離',
            detachTopFromGuide: 'ガイドからトップを分離',
            detachTopsFromGuides: 'ガイドから {{count}} 個のトップを分離',
            copy: 'コピー',
            pasteHere: 'ここに貼り付け',
            sheetTitle: '操作',
            back: '戻る',
            toastAligned: '{{applied}} 個を整列 — {{skipped}} 個をスキップ（ガイドにスナップ済みまたは付着済み）。',
            toastAlignedNone: '整列できるハンドルがありません — {{skipped}} 個をスキップ（ガイドにスナップ済みまたは付着済み）。',
            toastDistributed: '{{applied}} 個を分布 — {{skipped}} 個をスキップ（ガイドにスナップ済みまたは付着済み）。',
            toastDistributedNone: '分布できるハンドルがありません — {{skipped}} 個をスキップ（ガイドにスナップ済みまたは付着済み）。',
            toastRadialAligned:
                '{{applied}} 個を整列 — {{skipped}} 個をスキップ（該当するスナップがない、またはガイドが放射方向を満たせません）。',
            toastRadialAlignedNone:
                '整列できる目がありません — {{skipped}} 個をスキップ（該当するスナップがない、またはガイドが放射方向を満たせません）。',
            toastNormalAligned:
                '{{applied}} 個を整列 — {{skipped}} 個をスキップ（該当するスナップがない、またはガイドが法線方向を満たせません）。',
            toastNormalAlignedNone:
                '整列できる目がありません — {{skipped}} 個をスキップ（該当するスナップがない、またはガイドが法線方向を満たせません）。',
            flipHorizontal: '左右反転',
            flipVertical: '上下反転',
            toastFlipped: '{{applied}} 件を反転しました。{{skipped}} 件はスキップしました（ガイドにスナップしているか、接続されています）。',
            toastFlippedNone: '反転した項目はありません。{{skipped}} 件をスキップしました（ガイドにスナップしているか、接続されています）。',
            toastDirectionAligned:
                '{{applied}} 個を整列 — {{skipped}} 個をスキップ（ルートに方向がない、またはトップがガイドにスナップ済み）。',
            toastDirectionAlignedNone:
                '整列できる目がありません — {{skipped}} 個をスキップ（ルートに方向がない、またはトップがガイドにスナップ済み）。',
            handleAligned: '整列',
            handleVector: 'ベクトル',
            handleFree: 'フリー',
            linkAsParent: '…の親目としてリンク',
            linkAsChild: '…の子目としてリンク',
            makeGroup: 'グループ化',
            flipGroup: '前後を入れ替え',
            detachFromGroup: 'グループから分離',
            ungroup: 'グループ化を解除',
            markTurningChain: '立ち上がりに設定',
            removeTurningChain: '立ち上がりを解除',
            assignAsSpace: '空間として割り当て',
            bringToFront: '最前面へ',
            bringForward: '前面へ',
            sendBackward: '背面へ',
            sendToBack: '最背面へ',
        },

        crochetGroupsPanel: {
            title: 'グループ',
            empty: 'まだグループがありません',
            groupLabel: 'グループ {{n}}',
            togglePanel: 'グループ',
            highlight: 'キャンバス上で強調表示',
            flip: '前後を入れ替え',
            disband: 'グループ化を解除',
            select: 'グループを選択',
            cutUnder: '交差した棒を切って表示',
        },

        crochetAddStitchesDialog: {
            title: 'ガイドに編み目を追加',
            count: '数',
            startAngle: '開始角度',
            decrement: '数を減らす',
            increment: '数を増やす',
            stitchType: '編み目の種類',
            orient: 'ガイドに沿わせる',
            orientOn: 'オン',
            orientOff: 'オフ',
            snapBy: 'スナップ基準',
            snapByBase: 'ベース',
            snapByTop: 'トップ',
            autoWidth: '自動幅 — ガイドに合わせる',
            autoWidthOn: 'オン',
            autoWidthOff: 'オフ',
            width: '編み目の幅',
            height: '編み目の高さ',
            scaleValue: '{{value}}×',
            lockAspectRatio: '縦横比を固定',
            lockAspectRatioOn: 'オン',
            lockAspectRatioOff: 'オフ',
            cancel: 'キャンセル',
            add: '追加',
        },

        crochetCombination: {
            modeSingle: '単一',
            modeCombination: '組み合わせ',
            textboxLabel: '組み合わせ',
            textboxPlaceholder: 'e.g. sc, dc, ch',
            repeats: '繰り返し回数',
            summary: '{{combo}} · ×{{repeats}} = {{total}} 目',
            summaryWithSlots: '{{combo}} · ×{{repeats}} = {{stitches}} 目（{{slots}} スロット）',
            unknownStitch: '不明な編み方: {{token}}',
            unbalancedParens: '括弧が対応していません',
            invalidRepeat: '繰り返し回数が無効です',
            emptyGroup: '空のグループ',
            tooManyStitches: '編み目が多すぎます',
        },

        editorLayer: {
            group: 'エディターレイヤー',
            stitch: 'ステッチ',
            stitchTooltip: 'ステッチレイヤー（1）',
            annotation: '注釈',
            annotationTooltip: '注釈レイヤー（2）',
            select: '選択',
            startMarker: '編み始め記号',
            endMarker: '編み終わり記号',
            startMarkerTooltip: '編み始め記号（白三角）を配置',
            endMarkerTooltip: '編み終わり記号（黒三角）を配置',
            line: '線',
            lineTooltip: '接続線を描画（クリックしてドラッグ。端点は編み目にスナップ）',
            curve: '曲線',
            curveTooltip: '曲線の接続線を描画（クリックしてドラッグ。端点は編み目にスナップ）',
            circle: '円',
            circleTooltip: '円を配置（クリック。ダブルクリックすると中心と半径をドラッグ可能）',
            arc: '円弧',
            arcTooltip: '円弧を配置（クリック。ダブルクリックすると中心、半径、両端をドラッグ可能）',
            text: 'テキスト',
            textTooltip: 'テキストラベルを配置（クリックして入力、Esc または完了ボタンで終了）',
        },

        annotationInspector: {
            panelTitle: '注釈',
            empty: '注釈レイヤーにはまだ検査できる項目がありません。',
            angle: '角度（°）',
            width: '幅（%）',
            height: '高さ（%）',
            delete: '削除',
            color: '色',
            multi: {
                count_one: '{{count}} 件の注釈を選択中',
                count_other: '{{count}} 件の注釈を選択中',
            },
            symbol: {
                start: '編み始め記号',
                end: '編み終わり記号',
                path: '接続線',
                bezier: '曲線',
                circle: '円',
                arc: '円弧',
                text: 'テキストラベル',
            },
            text: {
                content: 'テキスト',
                size: '文字サイズ',
                fontFamily: 'フォント',
                families: {
                    sans: 'サンセリフ',
                    serif: 'セリフ',
                    mono: '等幅',
                },
                bold: '太字',
                italic: '斜体',
                underline: '下線',
                boldAbbrev: 'B',
                italicAbbrev: 'I',
                underlineAbbrev: 'U',
            },
            path: {
                startCap: '始点の端',
                endCap: '終点の端',
                style: '線のスタイル',
                width: '幅（×）',
                anchor: 'アンカー {{n}}',
                bound: '編み目に付着',
                free: 'フリー',
            },
            caps: {
                none: 'なし',
                arrow: '矢印',
                dot: '点',
                bar: 'バー',
            },
            styles: {
                solid: '実線',
                dashed: '破線',
                dotted: '点線',
            },
            bezier: {
                edit: '形状を編集',
                addAnchor: 'アンカーを追加',
                removeAnchor: 'アンカーを削除',
                handles: 'ハンドル',
            },
            handleTypes: {
                aligned: '整列',
                vector: 'ベクトル',
                free: 'フリー',
            },
            handleSides: {
                left: '左',
                right: '右',
            },
        },

        annotationActionRail: {
            undo: '元に戻す',
            redo: 'やり直す',
            delete: '削除',
            duplicate: '複製',
        },

        annotationToolbar: {
            editingCurve: '曲線を編集中',
            editingCircle: '円を編集中',
            editingArc: '円弧を編集中',
            editingText: 'テキスト編集中',
            exitEditMode: '編集モードを終了',
            color: '注釈の色',
        },

        annotationTextEditor: {
            label: '注釈テキスト',
        },

        crochetToolbar: {
            stitch: 'ステッチ',
            stitchTool: 'ステッチツール',
            guide: 'ガイド',
            guideTool: 'ガイドツール',
            place: '配置',
            edit: '編集',
            chain: 'チェーン',
            chainTooltip: 'チェーン（移動／回転）',
            sizing: 'サイズ変更',
            sizingTooltip: 'チェーン楕円の幅を変更',
            advanced: '詳細',
            advancedTooltip: 'キャップ／クロスバーの角度とクロスバーの位置を調整',
            editingGuide: 'ガイド編集中',
            exitEditMode: '終了',
        },

        crochetActionToolbar: {
            undo: '元に戻す',
            redo: 'やり直す',
            copy: 'コピー',
            paste: '貼り付け',
            pasteWithStitches: 'スナップ済みの編み目と一緒に貼り付け',
            pasteWithStructure: '編み目の構造ごと貼り付け',
            duplicate: '複製（直前の操作を繰り返す）',
            delete: '削除',
            alignDirection: '方向を揃える',
            alignDirectionHint: '線を引いて方向を指定します',
            toastDirectionLineAligned: '{{applied}} 個を整列 — {{skipped}} 個をスキップ（ガイドにスナップ済みまたは方向なし）。',
            toastDirectionLineAlignedNone: '整列できる目がありません — {{skipped}} 個をスキップ（ガイドにスナップ済みまたは方向なし）。',
            link: '編み目をリンク',
        },

        gridActionToolbar: {
            undo: '元に戻す',
            redo: 'やり直す',
        },

        // Stitch names
        stitch: {
            purl: '裏編み',
            knitBar: '表編み（縦線）',
            purlBar: '裏編み（横線）',
            slip: 'すべり目',
            slipWyif: 'すべり目 wyif',
            slipWyifCross: 'すべり目 wyif（クロス）',
            slipWyifFilled: 'すべり目 wyif（塗り）',
            slipWyifFilledBar: 'すべり目 wyif（塗り横線）',
            knitTbl: 'ねじり表編み',
            purlTbl: 'ねじり裏編み',
            purlTblBar: 'ねじり裏編み（横線）',
            knitTblArrow: 'ねじり表編み（矢印）',
            purlTblArc: 'ねじり裏編み（弧）',
        },

        crochet: {
            chainUp: '鎖編み（縦）',
            chainCenter: '鎖編み（横）',
            slipStitch: '引き抜き編み',
            singleCrochetX: '細編み（×）',
            singleCrochetCrosshair: '細編み（十字）',
            halfDoubleCrochet: '中長編み',
            title: 'かぎ針編み',
        },

        crochetRail: {
            stitch: {
                'double-crochet': '長編み',
                'half-double-crochet': '中長編み',
                'treble-crochet': '長々編み',
                'double-treble-crochet': '三巻き長編み',
                chain: '鎖編み',
                'chain-full': '鎖編み（全長）',
                'single-crochet': '細編み',
                'single-crochet-full': '細編み（全長）',
                'single-crochet-x': '細編み（×）',
                'single-crochet-x-full': '細編み（× 全長）',
                'single-crochet-directional': '細編み（方向）',
                'single-crochet-directional-full': '細編み（方向・全長）',
                'reverse-single-crochet': 'バック細編み',
                'reverse-single-crochet-full': 'バック細編み（全長）',
                'reverse-single-crochet-x': 'バック細編み（×）',
                'reverse-single-crochet-x-full': 'バック細編み（× 全長）',
                'twisted-single-crochet': 'ねじり細編み',
                'twisted-single-crochet-full': 'ねじり細編み（全長）',
                'twisted-single-crochet-x': 'ねじり細編み（×）',
                'twisted-single-crochet-x-full': 'ねじり細編み（× 全長）',
                'slip-stitch': '引き抜き編み',
                cluster: '玉編み（クラスター）',
                popcorn: 'ポップコーン編み',
                'front-post-single-crochet': '表引き細編み',
                'front-post-half-double-crochet': '表引き中長編み',
                'front-post-double-crochet': '表引き長編み',
                'front-post-treble-crochet': '表引き長々編み',
                'front-post-double-treble-crochet': '表引き三巻き長編み',
                'back-post-single-crochet': '裏引き細編み',
                'back-post-half-double-crochet': '裏引き中長編み',
                'back-post-double-crochet': '裏引き長編み',
                'back-post-treble-crochet': '裏引き長々編み',
                'back-post-double-treble-crochet': '裏引き三巻き長編み',
            },
            increase: '増し目 — 細編み',
            decrease: '減らし目 — 細編み',
            guide: {
                line: '直線',
                'concentric-circles': '同心円',
                'magic-ring': 'マジックリング（わ）',
                'concentric-arcs': '同心円弧',
                'bezier-curve': 'ベジェ曲線',
            },
            asym: {
                increase: {
                    'single-crochet': '増し目 — 細編み',
                    'double-crochet': '増し目 — 長編み',
                    'half-double-crochet': '増し目 — 中長編み',
                    'treble-crochet': '増し目 — 長々編み',
                    'double-treble-crochet': '増し目 — 三巻き長編み',
                    'front-post-single-crochet': '増し目 — 表引き細編み',
                    'front-post-half-double-crochet': '増し目 — 表引き中長編み',
                    'front-post-double-crochet': '増し目 — 表引き長編み',
                    'front-post-treble-crochet': '増し目 — 表引き長々編み',
                    'front-post-double-treble-crochet': '増し目 — 表引き三巻き長編み',
                    'back-post-single-crochet': '増し目 — 裏引き細編み',
                    'back-post-half-double-crochet': '増し目 — 裏引き中長編み',
                    'back-post-double-crochet': '増し目 — 裏引き長編み',
                    'back-post-treble-crochet': '増し目 — 裏引き長々編み',
                    'back-post-double-treble-crochet': '増し目 — 裏引き三巻き長編み',
                },
                decrease: {
                    'single-crochet': '減らし目 — 細編み',
                    'double-crochet': '減らし目 — 長編み',
                    'half-double-crochet': '減らし目 — 中長編み',
                    'treble-crochet': '減らし目 — 長々編み',
                    'double-treble-crochet': '減らし目 — 三巻き長編み',
                    'front-post-single-crochet': '減らし目 — 表引き細編み',
                    'front-post-half-double-crochet': '減らし目 — 表引き中長編み',
                    'front-post-double-crochet': '減らし目 — 表引き長編み',
                    'front-post-treble-crochet': '減らし目 — 表引き長々編み',
                    'front-post-double-treble-crochet': '減らし目 — 表引き三巻き長編み',
                    'back-post-single-crochet': '減らし目 — 裏引き細編み',
                    'back-post-half-double-crochet': '減らし目 — 裏引き中長編み',
                    'back-post-double-crochet': '減らし目 — 裏引き長編み',
                    'back-post-treble-crochet': '減らし目 — 裏引き長々編み',
                    'back-post-double-treble-crochet': '減らし目 — 裏引き三巻き長編み',
                },
                flyoutTitle: '増し目・減らし目',
                increaseSection: '増し目',
                decreaseSection: '減らし目',
                more: 'すべての増し目・減らし目',
                pin: 'バーにピン留め',
                unpin: 'バーから削除',
            },
            scrollUp: '上にスクロール',
            scrollDown: '下にスクロール',
            moreStitches: 'すべての編み方',
            category: {
                all: 'すべて',
                basic: '基本',
                posts: '引き上げ',
                clusters: '玉編み',
                textured: 'テクスチャー',
                special: '特殊',
            },
            flyout: {
                title: '編み方',
                searchPlaceholder: '編み方を検索…',
                noResults: '検索に一致する編み方はありません。',
                pin: 'バーにピン留め',
                unpin: 'バーから削除',
            },
        },

        crochetPieMenu: {
            scGroup: '細編み…',
            incDecGroup: '増し目／減らし目…',
            postsGroup: '表引き…',
            backPostsGroup: '裏引き…',
        },

        nav: {
            menuLabel: 'ナビゲーションメニューを開く',
            home: 'ホーム',
            knit: '棒針編み',
            crochet: 'かぎ針編み',
            help: 'ヘルプ',
            feedback: 'フィードバックを送る',
        },

        // Landing page
        landing: {
            tagline: 'ビジュアル編み図エディター。',
            openEditor: 'エディターを開く',
            knitTitle: '棒針編み',
            knitDescription: 'グリッド上で棒針編み図をデザインします。',
            crochetTitle: 'かぎ針編み',
            crochetDescription: '編み目アイコンでかぎ針編みパターンをデザインします。',
            patternTitle: 'パターン',
            patternDescription: 'テキストと図でパターンを編集します。',
        },

        offlineBoot: {
            copying: '作品をコピーしています… {{done}} / {{total}}',
            copyFailed: '作品をコピーできませんでした。次回 {{appName}} の起動時にもう一度試みます。',
        },

        copyCode: {
            copied: 'コピーしました',
            fallback: 'このコードをコピーしてください：',
        },

        offlineSite: {
            landing: {
                title: '{{appName}} オフラインアプリ',
                getIt: '{{appName}} → 設定 → オフラインアプリから入手できます。',
            },
            install: {
                title: '{{appName}} をインストール',
                preparing: 'ダウンロードを準備しています…',
                progress: '{{appName}} {{version}} をダウンロードしています… {{done}} / {{total}} ファイル',
                ready: '準備完了 — インターネットなしで使えます',
                installButton: 'アプリをインストール',
                openNow: '今すぐ開く',
                safariDock: '「ファイル > Dockに追加」',
                iosHomeScreen: '「共有」→「ホーム画面に追加」',
                bookmark: 'このタブで利用できます — ブックマークしてください。',
                retry: 'もう一度試す',
                copyingStart: '{{appName}} から作品をコピーしています…',
                copying: '{{appName}} から作品をコピーしています… {{done}} / {{total}}',
                skip: 'スキップ',
                workCopied_one: '作品をコピーしました（{{count}} 件）。',
                workCopied_other: '作品をコピーしました（{{count}} 件）。',
                workNotCopied: '作品はコピーされませんでした。あとから設定 → データ管理でインポートできます。',
                openFromDock: 'Dock から {{appName}} を開いてください。そこでインストールが完了します。',
                openFromHomeScreen: 'ホーム画面から {{appName}} を開いてください。そこでインストールが完了します。',
                copyInstallCode: 'インストールコードをコピー',
                installedInApp: 'インストール済み',
                importHintInApp:
                    '作品を移すには、Safari の {{appName}} で「すべてエクスポート」（設定 → データ管理）を使い、ここで「インポート」してください。',
            },
            finish: {
                title: '{{appName}} のインストールを完了',
                pasteLabel: 'インストールコードを貼り付け',
                continue: '続ける',
                notACode: 'これはインストールコードではありません。',
                expired: 'このコードは有効期限が切れています。{{appName}} → 設定 → オフラインアプリで新しいコードを取得してください。',
            },
            update: {
                title: '{{appName}} をアップデート',
                ready: 'アップデートしました — {{appName}} を開いています…',
            },
            errors: {
                expired: 'このリンクは有効期限が切れています。{{appName}} に戻って、もう一度「オフラインアプリを入手」をクリックしてください。',
                unauthorized: 'このリンクは無効です。{{appName}} に戻って、もう一度「オフラインアプリを入手」をクリックしてください。',
                'missing-token': 'このページにはインストールリンクが必要です。{{appName}} に戻って「オフラインアプリを入手」をクリックしてください。',
                'not-enough-storage': '空き容量が不足しています：約 {{mb}} MB の空き容量が必要です。',
                network: 'ダウンロードが中断されました。接続を確認して、もう一度お試しください。',
                integrity: 'ダウンロードした内容が想定と一致しなかったため、破棄しました。もう一度お試しください。',
                'no-build': 'オフラインアプリはまだ提供されていません。しばらくしてからもう一度お試しください。',
                unsupported: 'このブラウザではオフラインアプリを実行できません。最新の Chrome、Edge、Safari、または Firefox をお試しください。',
            },
        },

        offlineUpdate: {
            title: 'オフラインアプリをアップデート',
            upToDate: '最新の状態です。',
            subscribe: 'インストール済みの {{from}} は引き続き使えます。{{current}} を入手するには、サブスクリプションに登録してください。',
            subscribeNoFrom: 'インストール済みのオフラインアプリは引き続き使えます。{{current}} を入手するには、サブスクリプションに登録してください。',
            trial: 'オフラインアプリは有料プランに含まれています。',
            updating: 'アップデートを準備しています…',
            unavailable: '現在、オフラインアプリはご利用いただけません。',
            error: 'アップデートを開始できませんでした。もう一度お試しください。',
            copyUpdateCode: 'アップデートコードをコピー',
            codeSteps: '{{appName}}（オフライン）で、設定 → 情報 →「アップデートコードを貼り付け」に貼り付けてください。このコードは 15 分間有効です。',
        },

        dashboard: {
            title: 'ワークスペース',
            filterAll: 'すべて',
            filterCrochet: 'かぎ針',
            filterKnit: '棒針',
            filterPatterns: 'パターン',
            filterArchived: 'アーカイブ済み',
            bandCrochet: 'かぎ針編み',
            bandKnit: '棒針編み',
            bandPatterns: 'パターン',
            seeAll: 'すべて表示',
            newButton: '新規作成',
            newCrochet: '新規かぎ針編み',
            newKnit: '新規棒針編み',
            newPattern: '新規パターン',
            empty: 'まだ何もありません。「新規作成」から最初の作品を作りましょう。',
            loadFailed: 'ワークスペースを読み込めませんでした。もう一度お試しください。',
            storageUnavailable: 'このブラウザではストレージを利用できません。',
            importHint: 'オンライン版の {{appName}} に作品がありますか？',
            importHintLink: '作品をインポート',
            counter: 'アクティブな編み図：{{used}} / {{limit}} 件',
        },

        notFound: {
            title: '編み目を落としちゃったみたい',
            description: 'このページはほどけてしまったようで、ここには見つかりません。',
            backHome: 'ホームに戻る',
        },

        patternEditor: {
            title: 'パターンエディター',
            description: 'リッチテキストと図でかぎ針編みや棒針編みのパターンを編集します。',
            textPlaceholder: 'パターンの説明を入力…',
            fonts: {
                warningTitle: 'パターンのフォントを読み込めませんでした',
                warningDescription: 'PDFでは別のフォントが使われ、改ページの位置が変わる場合があります。',
                notice: '{{fonts}}を読み込めなかったため、改ページは保存されていません。オンラインに戻ったら再読み込みしてください。',
                warning: '{{fonts}}を読み込めませんでした。PDFでは改行や改ページが異なる場合があります。',
            },
            legend: {
                insert: '編み目記号の凡例を挿入',
                emptyChart: 'この編み図にはまだ編み目がありません',
                deleteRow: '行を削除',
                tooLarge: 'この編み図は編み目の種類が多すぎて凡例にできません。',
                refreshFromChart: '編み図から更新',
                // The data-mode error panel's way out (legend and written instructions alike).
                close: '閉じる',
                refreshConfirm: {
                    title: '編集内容を置き換えますか？',
                    body: '更新すると、このブロックは編み図の現在の編み目に置き換わります。このブロックへの編集は失われます。',
                    confirm: '更新',
                    cancel: 'キャンセル',
                },
            },
            instructions: {
                insert: '編み方を挿入',
                notesOmitted_one: '挿入しました。編み図のメモ {{count}} 件は含まれていません。編み図を確認してください。',
                notesOmitted_other: '挿入しました。編み図のメモ {{count}} 件は含まれていません。編み図を確認してください。',
                emptyChart: 'この編み図にはまだ編み方にできる編み目がありません',
                notesOmittedRefresh_one: '更新しました。編み図のメモ {{count}} 件は含まれていません。編み図を確認してください。',
                notesOmittedRefresh_other: '更新しました。編み図のメモ {{count}} 件は含まれていません。編み図を確認してください。',
                tooLarge: 'この編み図は大きすぎるため、編み方として挿入できません。',
            },
            paperErrors: {
                edge: '用紙の端で切れています',
                tooTall: 'この段落は1ページに収まらない高さです',
                warning: {
                    title: '一部の内容が切れてしまいます',
                    description: 'これらのページには用紙に収まらない内容があり、PDF では切れてしまいます。',
                    page: '{{page}} ページ目：{{reasons}}',
                    goBack: '戻る',
                    exportAnyway: 'このまま書き出す',
                    // Short forms for the per-page list, which joins them mid-sentence.
                    reasons: {
                        edge: '用紙の端で切れている部分',
                        tooTall: '1ページに収まらない高さの段落',
                    },
                },
            },
            exportPdf: 'PDF を書き出し',
            addText: 'テキストボックスを追加',
            addImage: '画像を追加',
            addDiagram: '編み図を追加',
            resizeElement: 'ブロックのサイズを変更',
            language: {
                label: 'パターンの言語',
            },
            // The running header and footer dialog (SP-144). {page}, {pages} and {name} stay literal in every language.
            headerFooter: {
                button: 'ヘッダーとフッター',
                title: 'ヘッダーとフッター',
                description: 'このパターンの各ページの余白に表示されます。',
                header: 'ヘッダー',
                footer: 'フッター',
                left: '左',
                center: '中央',
                right: '右',
                insertPage: 'ページ番号',
                insertPages: '総ページ数',
                insertName: 'パターン名',
                insertPreset: '1 / 5 ページ',
                hint: '{page}、{pages}、{name} は、ページ番号、総ページ数、パターン名に置き換わります。',
                hideOnFirstPage: '1ページ目（表紙）には表示しない',
                preview: 'プレビュー',
                previewPage: '{{number}} ページ',
                done: '完了',
                cancel: 'キャンセル',
            },
            paperSize: {
                label: '用紙サイズ',
                letter: 'レター（8.5 × 11 インチ）',
                a4: 'A4（210 × 297 mm）',
            },
            menu: {
                cut: '切り取り',
                copy: 'コピー',
                paste: '貼り付け',
                delete: '削除',
                duplicate: '複製',
                bringToFront: '最前面へ',
                refreshDiagram: '編み図から更新',
            },
            pages: {
                label: '{{number}} ページ',
                actions: '{{number}} ページの操作',
                add: 'ページを追加',
                newPageSlot: 'ここにドロップして新しいページへ',
                addAfter: '後ろにページを追加',
                moveUp: 'ページを上へ移動',
                moveDown: 'ページを下へ移動',
                delete: 'ページを削除',
                deleteTitle: '{{number}} ページを削除しますか？',
                deleteBody_one: 'このページのブロックも削除されます。',
                deleteBody_other: 'このページの {{count}} 個のブロックも削除されます。',
                cancel: 'キャンセル',
                confirmDelete: 'ページを削除',
            },
            zoom: {
                in: '拡大',
                out: '縮小',
                fitPage: 'ページ全体を表示',
                fitWidth: '幅に合わせる',
                level: 'ズーム倍率',
            },
            textFlow: {
                continuation: '続きのテキストです。ドラッグでこのページ上を移動、端をドラッグでサイズ変更できます。',
                resetContinuation: '位置とサイズをリセット',
            },
            history: {
                undoStep: '{{step}}を元に戻す',
                redoStep: '{{step}}をやり直す',
                steps: {
                    addText: 'テキストボックスの追加',
                    addImage: '画像の追加',
                    insertChart: 'グラフの挿入',
                    refreshChart: 'グラフの更新',
                    insertLegend: '凡例の挿入',
                    editLegend: '凡例の編集',
                    refreshLegend: '凡例の更新',
                    insertInstructions: '編み方の挿入',
                    refreshInstructions: '編み方の更新',
                    move: '移動',
                    resize: 'サイズ変更',
                    moveContinuation: '続きテキストの移動',
                    resizeContinuation: '続きテキストのサイズ変更',
                    resetContinuation: '続きテキストのリセット',
                    editText: 'テキスト編集',
                    delete: '削除',
                    duplicate: '複製',
                    bringToFront: '最前面へ移動',
                    paperSize: '用紙サイズ',
                    patternLanguage: 'パターンの言語',
                    headerFooter: 'ヘッダーとフッター',
                    addPage: 'ページの追加',
                    deletePage: 'ページの削除',
                    movePage: 'ページの移動',
                },
            },
            toolbar: {
                undo: '元に戻す',
                redo: 'やり直す',
                blockType: '文字スタイル',
                blockNormal: '本文',
                blockH1: '見出し 1',
                blockH2: '見出し 2',
                blockH3: '見出し 3',
                blockBullet: '箇条書きリスト',
                blockNumbered: '番号付きリスト',
                blockCheck: 'チェックリスト',
                blockQuote: '引用',
                blockCode: 'コードブロック',
                fontFamily: 'フォント',
                fontSize: '文字サイズ',
                decreaseFontSize: '文字サイズを小さく',
                increaseFontSize: '文字サイズを大きく',
                bold: '太字',
                italic: '斜体',
                underline: '下線',
                code: 'インラインコード',
                link: 'リンクを挿入',
                bulletList: '箇条書きリスト',
                numberedList: '番号付きリスト',
                moreFormats: 'その他の文字書式',
                strikethrough: '取り消し線',
                subscript: '下付き文字',
                superscript: '上付き文字',
                clearFormatting: '書式をクリア',
                textColor: '文字色',
                bgColor: '背景色',
                customColor: 'カスタムカラー',
                align: '配置',
                alignLeft: '左揃え',
                alignCenter: '中央揃え',
                alignRight: '右揃え',
                alignJustify: '両端揃え',
                indent: 'インデントを増やす',
                outdent: 'インデントを減らす',
                linkPrompt: 'URL を入力：',
                scrollLeft: 'ツールバーを左にスクロール',
                scrollRight: 'ツールバーを右にスクロール',
            },
            pdfExport: {
                preparing: 'PDF を準備中…',
                ready: 'PDF の準備ができました。',
                save: 'PDF を保存',
                offlineFallback: 'PDF ファイルの作成には {{appName}} への接続が必要です。代わりに印刷ダイアログを開きます。「PDF に保存」を選んでください。',
                failedFallback: 'PDF ファイルを作成できませんでした。代わりに印刷ダイアログを開きます。「PDF に保存」を選んでください。',
            },
        },

        gridPieMenu: {
            knit: '表編み',
            purl: '裏編み',
            'knit-bar': '表編み（縦線）',
            'purl-bar': '裏編み（横線）',
            empty: '空',
            slipGroup: 'すべり目…',
            slip: 'すべり目',
            'slip-wyif': 'すべり目 wyif',
            'slip-wyif-cross': 'すべり目 wyif（クロス）',
            'slip-wyif-filled': 'すべり目 wyif（塗り）',
            'slip-wyif-filled-bar': 'すべり目 wyif（塗り横線）',
            tblGroup: 'ねじり目…',
            'knit-tbl': 'ねじり表編み',
            'purl-tbl': 'ねじり裏編み',
            'purl-tbl-bar': 'ねじり裏編み（横線）',
            'knit-tbl-arrow': 'ねじり表編み（矢印）',
            'purl-tbl-arc': 'ねじり裏編み（弧）',
        },

        // Icon Handoff Page
        iconHandoff: {
            title: 'アイコン引き継ぎ',
            intro: 'このページにはアプリで使用されるすべてのアイコンが一覧表示されます。デザイナーは置き換え用の SVG を',
            introCode: 'public/designer-icons/<slug>/<slug>.svg',
            introClosing: ' に配置すると「デザイナー」列に表示されます。',
            conventionTitle: '規約',
            conventionBody:
                'すべてのアイコンは @/assets/icons からインポートします。カスタム SVG アイコンは src/assets/icons/ に React コンポーネントとして配置します。Lucide アイコンは単一の lucide.ts ファイルから再エクスポートします。',
            sectionCustomTitle: 'カスタムアプリアイコン',
            sectionCustomSubtitle: '自製の React SVG コンポーネント。',
            sectionLucideTitle: 'Lucide アイコン',
            sectionLucideSubtitle: 'lucide-react から再エクスポート。他の場所で lucide-react を直接インポートしないでください。',
            sectionCursorsTitle: 'カーソル',
            sectionCursorsSubtitle:
                'SVG マスターは src/assets/cursors/ にあり、scripts/build-cursors.sh で public/cursors/ の 32px/64px PNG に変換されます。ホットスポットは @1x 座標での有効ピクセルで、src/cursors/cursor-registry.ts で定義されています。',
            tableName: 'エクスポート名',
            tableState: 'ステート',
            tableCurrent: '現在',
            tableDesigner: 'デザイナー',
            tableHotspot: 'ホットスポット',
            tableUsedFor: '用途',
            footer:
                '新しいアイコンを追加するには、src/assets/icons/index.ts からエクスポートし、icon-handoff-data.ts に行を追加してください。',
        },
    },
} as const;

export default ja;
